import Request from "../../lib/request";
import { PROJECT_USER_ID } from "../../constants/storageKeys";
import { PAGE } from "../../constants/filters";
import {
  CONTACT_REPORT_API,
  PROJECT_USERS_API,
  REPORTS_API
} from "../../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;

export const getSummaryList = (page_number, finalFilter) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${REPORTS_API}/${CONTACT_REPORT_API}?${PAGE}=${page_number}`,
    needToken: true,
    data: finalFilter
  });
};
